// @ts-ignore
import Quill from '@cimpress-technology/quill/core';

export const { Attributor, Scope } = Quill.import('parchment');

export default new Attributor('strokePosition', 'data-stroke-position', { scope: Scope.INLINE });
export const BlockStrokePositionAttributor = new Attributor(
    'blockStrokePosition',
    'data-stroke-position',
    { scope: Scope.BLOCK },
);
